import { useQuery, type UseQueryResult } from 'react-query';
import { type TableParamsType } from '../../types/common';
import { WarrantExerciseService } from '@wealthlane/api-services/wealthlane-captable-service';
import type { PagedResultDto_WarrantExerciseListDto } from '@wealthlane/api-services/wealthlane-captable-service';

const useGetWarrantExerciseList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  isTableInfoInitialized?: boolean
): UseQueryResult<PagedResultDto_WarrantExerciseListDto | undefined, unknown> => {
  const { filter, sorting, skipCount, maxResultCount, status } = tableInfo;
  // The generated client takes WarrantId between status and sorting; this list is not scoped to one warrant.
  const warrantId = undefined;
  const exerciseList = useQuery(
    ['getWarrantExerciseList', filter, sorting, skipCount, maxResultCount, status],
    async () => {
      return await handleRequest(
        WarrantExerciseService.getApiCapTableApiAppWarrantExerciseWarrantExerciseList(
          filter,
          status,
          warrantId,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    },
    {
      enabled: isTableInfoInitialized !== false,
    }
  );

  return exerciseList;
};

export default useGetWarrantExerciseList;
